__turbopack_context__.v({
  "main-feature": "main-data-module-scss-module__B-f0Za__main-feature",
  "main-features-container": "main-data-module-scss-module__B-f0Za__main-features-container",
  "placeholder": "main-data-module-scss-module__B-f0Za__placeholder",
  "title": "main-data-module-scss-module__B-f0Za__title",
});
